import { all } from "redux-saga/effects";

import getAvatarSaga from "./getAvatar";
import getSignatureSaga from "./getSignature";
import getWorkInformationSaga from "./getWorkInformation";
import getBankInformationSaga from "./getBankInformation";
import getBasicInformationSaga from "./getBasicInformation";
import getMaritalInformationSaga from "./getMaritalInformation";
import getLanguageInformationSaga from "./getLanguageInformation";
import getEducationInformationSaga from "./getEducationInformation";
import getResidenceInformationSaga from "./getResidenceInformation";
import getCertificationInformationSaga from "./getCertificationInformation";
import getWorkPerformanceResultSaga from "./getWorkPerformanceResult";
import postFormEditPersonalInformationSaga from "./postFormEditPersonalInformation";
import getHistoryTimelineSaga from "./getHistoryTimeline";
import getHistoryDetailSaga from "./getHistoryDetail";
import uploadFileSaga from "./uploadFile";
import getPermissionEditSaga from "./getPermissionEdit";
import getCertificationProfessionalSaga from "./getCertificationProfessional";

export default function* personnelInformationSaga() {
  yield all([
    getAvatarSaga(),
    getSignatureSaga(),
    getWorkInformationSaga(),
    getBankInformationSaga(),
    getBasicInformationSaga(),
    getMaritalInformationSaga(),
    getLanguageInformationSaga(),
    getEducationInformationSaga(),
    getResidenceInformationSaga(),
    getCertificationInformationSaga(),
    getWorkPerformanceResultSaga(),
    postFormEditPersonalInformationSaga(),
    getHistoryTimelineSaga(),
    getHistoryDetailSaga(),
    uploadFileSaga(),
    getPermissionEditSaga(),
    getCertificationProfessionalSaga(),
  ]);
}
